import React from 'react';
import { Page } from '@react-pdf/renderer';
import Header from './Header';
import Footer from './Footer';

interface PageProps {
  children?: React.ReactNode;
  meta?: any;
}

const ReportPage = ({ children, meta }: PageProps) => (
  <Page orientation="landscape" style={{ padding: 20 }}>
    <Header {...meta} />
    {children}
    <Footer />
  </Page>
);

export default ReportPage;
